<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" @click="handleTemplate()">
          下载模板<i class="el-icon-download el-icon--right"></i>
        </el-button>
        <el-button type="primary" icon="el-icon-upload2" @click="handleImport">导入数据 </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.otherproject_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
    <el-dialog title="创收项目数据导入" append-to-body :visible.sync="excelBox" width="555px">
      <avue-form :option="excelOption" v-model="excelForm" :upload-after="uploadAfter">
        <template slot="excelTemplate"> </template>
      </avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/demo/otherproject';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      excelBox: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        searchMenuSpan: 6,
        columnBtn: false,
        editBtn: false,
        menuWidth: 100,
        column: [
          {
            label: '项目名称',
            prop: 'projectName',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入项目名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '项目类型',
            prop: 'projectType',
            type: 'select',
            search: true,
            dicUrl: '/api/blade-system/dict/dictionary?code=project_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            rules: [
              {
                required: true,
                message: '请选择项目类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '上报时间',
            prop: 'dateStartRange',
            searchSpan: 10,
            search: true,
            searchRange: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
          },
          {
            label: '开始时间',
            prop: 'startTime',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
          },
          {
            label: '结束时间',
            prop: 'endTime',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
          },
          {
            label: '租赁金额',
            prop: 'rentFee',
            precision: 2,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              {
                message: '请输入租赁金额',
                trigger: 'change',
              },
              { pattern: /^\d+(\.\d{0,2})?$/, message: '格式错误，请输入不超过两位位小数的正数' },
            ],
          },
          {
            label: '管理费',
            prop: 'managerFee',
            precision: 2,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              {
                message: '请输入管理费',
                trigger: 'change',
              },
              { pattern: /^\d+(\.\d{0,2})?$/, message: '格式错误，请输入不超过两位位小数的正数' },
            ],
          },
          {
            label: '能耗费用',
            prop: 'energyFee',
            precision: 2,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              {
                message: '请输能耗费用',
                trigger: 'change',
              },
              { pattern: /^\d+(\.\d{0,2})?$/, message: '格式错误，请输入不超过两位位小数的正数' },
            ],
          },
          {
            label: '其他费用',
            prop: 'otherFee',
            precision: 2,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              { pattern: /^\d+(\.\d{0,2})?$/, message: '格式错误，请输入不超过两位位小数的正数' },
            ],
          },
          {
            label: '起始时间',
            prop: 'dateRange',
            searchRange: true,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            hide: true,
            rules: [
              {
                required: true,
                message: '请选择起始时间',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '联系人',
            prop: 'contactName',
            search: true,
          },
          {
            label: '联系电话',
            prop: 'contactPhone',
            rules: [
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '手机号格式错误' },
              {
                trigger: 'blur',
                min: 11,
                max: 11,
                message: '请输入11位电话',
              },
            ],
          },
          {
            label: '上报时间',
            prop: 'createTime',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
          },
          {
            label: '备注说明',
            prop: 'remark',
            maxlength: 15,
            span: 24,
            type: 'textarea',
          },
        ],
      },
      data: [],
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '数据上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '数据上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/v4ward/otherProject/import-other',
          },
          /*  {
            label: '数据覆盖',
            prop: 'isCovered',
            type: 'switch',
            align: 'center',
            width: 80,
            dicData: [
              {
                label: '否',
                value: 0,
              },
              {
                label: '是',
                value: 1,
              },
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: '请选择是否覆盖',
                trigger: 'blur',
              },
            ],
          },*/
          /*{
            label: '模板下载',
            prop: 'excelTemplate',
            formslot: true,
            span: 24,
          },*/
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.otherproject_add, true),
        viewBtn: this.vaildData(this.permission.otherproject_view, true),
        delBtn: this.vaildData(this.permission.otherproject_delete, false),
        editBtn: this.vaildData(this.permission.otherproject_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      row.startTime = row.dateRange[0];
      row.endTime = row.dateRange[1];
      console.log(row);
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          let timeRange = [];
          timeRange.push(data.startTime);
          timeRange.push(data.endTime);
          this.form.dateRange = timeRange;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.dateStartRange) {
        this.query.timeStart = this.query.dateStartRange[0];
        this.query.timeEnd = this.query.dateStartRange[1];
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    // 导入
    uploadAfter(res, done, loading, column) {
      this.excelBox = false;
      this.excelForm.excelFile = '';
      this.onLoad();
      done();
    },
    handleTemplate() {
      window.open(`/api/v4ward/otherProject/export-template?Blade-Auth=${getToken()}`);
    },
    handleImport() {
      this.excelBox = true;
    },
  },
};
</script>

<style></style>
